import { CardImage, CardType } from '~types';

const CARD_IMAGES: CardImage = {
  JCB: '/mock/jcb.png',
  VISA: '/mock/visa.png',
  AMEX: '/mock/amex.png',
  DISCOVER: '/mock/discover.png',
  MASTERCARD: '/mock/mastercard.png',
  ELECTRON: '',
  MAESTRO: '',
  DANKORT: '',
  INTERPAYMENT: '',
  UNIONPAY: '',
  DINERS: '',
};

export function getCardImage(card: CardType) {
  const modifiedCardBrand = card?.toUpperCase() as CardType;

  return CARD_IMAGES[modifiedCardBrand];
}

export function getCardImages() {
  return CARD_IMAGES;
}
